/**
 * Component to display social icons in header/footer
 */

import { NetworkIcon } from "./icons/NetworkIcon";
import Link from "./tailwind/Link";

const SOCIAL_LINK_TWITTER = "https://twitter.com/piratenation";

const FONT_SIZE = "28px";

export function SocialIcons() {
  return (
    <div className="flex gap-5 items-center [&>a]:opacity-40 [&>a:hover]:opacity-100">
      <Link href={SOCIAL_LINK_TWITTER} target="_blank" className="w-full">
        <NetworkIcon network="twitter" fontSize={FONT_SIZE} />
      </Link>
    </div>
  );
}
